window.IndiaPage = function IndiaPage({ setActiveTab }) {
  const [indiaContent, setIndiaContent] = React.useState(null);

  React.useEffect(() => {
    fetchIndiaContent();
    const handleSync = () => fetchIndiaContent();
    window.addEventListener('novatek_content_updated', handleSync);
    window.addEventListener('storage', handleSync);
    return () => {
      window.removeEventListener('novatek_content_updated', handleSync);
      window.removeEventListener('storage', handleSync);
    };
  }, []);

  const fetchIndiaContent = async () => {
    try {
      const res = await window.apiClient.get('content.php');
      if (res.success && res.data) {
        if (res.data.india_page) {
          setIndiaContent(res.data.india_page);
        } else if (res.data.section_key === 'india_page' || res.data.content) {
          setIndiaContent(res.data.content || res.data);
        }
      }
    } catch (e) {
      console.warn('India page content fetch error:', e);
    }
  };

  const bgImage = window.resolveMediaUrl(indiaContent?.bgImage || "/api/storage/banners/india_hero_bg.jpg", 'banner');
  const subtitle = indiaContent?.subtitle || "Engineered in India, Empowering the World";
  const quote = indiaContent?.quote || "NOVATEK is an Indian company, driven by innovation, precision and a commitment to build a stronger, self-reliant India.";
  const lionLogo = window.resolveMediaUrl(indiaContent?.lionLogo || "/make_in_india_lion.png", 'banner');

  return (
    <div 
      className="relative min-h-[calc(100vh-5rem)] w-full bg-cover bg-center flex flex-col justify-between p-6 sm:p-10 select-none overflow-hidden font-sans"
      style={{ backgroundImage: `url("${bgImage}")` }}
    >
      
      {/* Top Floating Close Button */}
      <button 
        onClick={() => setActiveTab('home')}
        className="absolute top-6 right-6 sm:top-8 sm:right-8 z-30 h-11 w-11 bg-white/90 hover:bg-white text-slate-800 hover:text-slate-950 rounded-full shadow-lg backdrop-blur-md flex items-center justify-center transition-all cursor-pointer border border-slate-200 hover:scale-105 active:scale-95"
        title="Return to Home"
      >
        <span className="material-symbols-outlined text-2xl">close</span>
      </button>

      {/* Main Middle Hero Content Grid - Shifted slightly down */}
      <div className="max-w-7xl w-full mx-auto flex-1 flex flex-col items-center justify-center py-6 pt-12 sm:pt-16 relative z-10 my-auto">
        
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* Left Column Spacer (Flag & Monuments are in the background image) */}
          <div className="hidden lg:block lg:col-span-2"></div>

          {/* Center Column: Logo, Heading & Quote */}
          <div className="lg:col-span-8 flex flex-col items-center text-center space-y-6">
            
            {/* Novatek Logo - Increased Size */}
            <div className="flex flex-col items-center gap-2">
              <img 
                src="/logo-removebg-preview.png" 
                onError={(e) => { e.target.src = "/logo.png"; }}
                alt="NOVATEK Logo" 
                className="h-20 sm:h-28 lg:h-32 w-auto object-contain drop-shadow-lg" 
              />
              <span className="font-mono text-xs sm:text-sm tracking-widest text-slate-700 uppercase font-black pt-1">
                Engineering the future
              </span>
            </div>

            {/* Main Heading */}
            <div className="space-y-2 pt-2">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight flex items-center justify-center gap-3">
                <span className="text-slate-900 font-black">Proudly</span>
                <span className="bg-gradient-to-r from-orange-500 via-amber-500 to-emerald-600 bg-clip-text text-transparent">Indian</span>
              </h1>
              <p className="font-sans text-sm sm:text-base font-black text-slate-800 uppercase tracking-widest pt-1">
                {subtitle}
              </p>
            </div>

            {/* Quote Card */}
            <div className="relative bg-white/90 backdrop-blur-md border border-blue-200/90 rounded-3xl p-8 sm:p-10 shadow-xl max-w-3xl w-full my-4 border-t-4 border-t-orange-500">
              <span className="absolute -top-5 left-8 text-blue-500 text-6xl font-sans leading-none">“</span>
              <p className="font-sans text-slate-900 text-base sm:text-lg lg:text-xl font-bold italic leading-relaxed px-4 sm:px-6">
                {quote}
              </p>
              <span className="absolute -bottom-9 right-8 text-blue-500 text-6xl font-sans leading-none">”</span>
            </div>

          </div>

          {/* Right Column: Make in India Lion Logo */}
          <div className="lg:col-span-2 flex justify-center lg:justify-end items-center">
            <div className="flex flex-col items-center space-y-2 group">
              <img 
                src={lionLogo} 
                alt="Make In India Lion" 
                onError={(e) => { e.target.src = "/make_in_india_lion.png"; }}
                className="w-44 sm:w-52 h-auto object-contain drop-shadow-md transition-transform group-hover:scale-105" 
              />
            </div>
          </div>

        </div>

      </div>

    </div>
  );
};
